import _objectSpread from "F:/bio_link_pc/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import _asyncToGenerator from "F:/bio_link_pc/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue";
var _hoisted_1 = {
  class: "cancel-content"
};
var _hoisted_2 = {
  class: "message"
};
var _hoisted_3 = {
  class: "dialog-footer"
};
import { ref, watch } from "vue";
import { ElMessageBox, ElMessage } from "element-plus";
import { approval_cancel } from "@/api/apis";
export default {
  __name: 'CancelDialog',
  props: {
    modelValue: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: "提示"
    },
    message: {
      type: String,
      default: "确认要执行此操作吗?"
    },
    confirmText: {
      type: String,
      default: "确定"
    },
    cancelText: {
      type: String,
      default: "取消"
    },
    confirmType: {
      type: String,
      default: "primary"
    },
    width: {
      type: String,
      default: "400px"
    },
    // 撤销API函数
    cancelApi: {
      type: Function,
      default: null
    },
    // 撤销所需的参数
    cancelParams: {
      type: Object,
      default: () => ({})
    },
    // 加载状态
    loading: {
      type: Boolean,
      default: false
    }
  },
  emits: ["update:modelValue", "success", "close", "error"],
  setup(__props, _ref) {
    var {
      emit: __emit
    } = _ref;
    var props = __props;
    var emit = __emit;
    var dialogVisible = ref(false);
    watch(() => props.modelValue, val => {
      dialogVisible.value = val;
    });
    watch(() => props.cancelParams, val => {
      console.log("cancelParams:", props.cancelParams);
    });
    watch(dialogVisible, val => {
      emit("update:modelValue", val);
    });
    var handleClose = () => {
      dialogVisible.value = false;
      emit("close");
    };
    var handleConfirm = /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator(function* () {
        try {
          var transferData = _objectSpread({}, props.cancelParams);
          approval_cancel(transferData, "put").then(res => {
            if (res.code == 200) {
              ElMessage({
                type: "success",
                message: "操作成功"
              });
              dialogVisible.value = false;
              emit("success");
            }
          });
        } catch (error) {
          console.error("操作失败:", error);
        }
      });
      return function handleConfirm() {
        return _ref2.apply(this, arguments);
      };
    }();
    return (_ctx, _cache) => {
      var _component_el_button = _resolveComponent("el-button");
      var _component_el_dialog = _resolveComponent("el-dialog");
      return _openBlock(), _createBlock(_component_el_dialog, {
        modelValue: dialogVisible.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => dialogVisible.value = $event),
        width: __props.width,
        "align-center": "",
        onClose: handleClose
      }, {
        footer: _withCtx(() => [_createElementVNode("div", _hoisted_3, [_createVNode(_component_el_button, {
          onClick: handleClose
        }, {
          default: _withCtx(() => [_createTextVNode(_toDisplayString(__props.cancelText), 1)]),
          _: 1
        }), _createVNode(_component_el_button, {
          type: "primary",
          onClick: handleConfirm,
          loading: __props.loading
        }, {
          default: _withCtx(() => [_createTextVNode(_toDisplayString(__props.confirmText), 1)]),
          _: 1
        }, 8, ["loading"])])]),
        default: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_cache[1] || (_cache[1] = _createElementVNode("i", {
          class: "el-icon-warning warning-icon"
        }, null, -1)), _createElementVNode("span", _hoisted_2, _toDisplayString(__props.message), 1)])]),
        _: 1
      }, 8, ["modelValue", "width"]);
    };
  }
};